<template>
	<div class="wrap">
		<div class="container">
			<div class="detail-orderDetail">
				<div class="detail-orderBox">
					<ul>
						<li>订单号:{{ order.order_no }}</li>
						<li>时间:{{ order.add_time_time }}</li>
						<li>
							<van-row type="flex" justify="start">
								状态:&nbsp;<van-row class="of_time" type="flex">{{ order.status_name }}</van-row>
							</van-row>
						</li>
					</ul>
				</div>
				<div class="detail-orderBox detail-orderBox-li-color">
					<ul>
						<li>邮寄方式</li>
						<li>
							<div v-show="order.express_name">{{ order.express_name }}</div>
							<div v-show="order.express_number">{{ order.express_number }}</div>
						</li>
					</ul>
				</div>
				<!-- <div class="detail-orderBox detail-orderBox-li-color detail-orderBox-top">
					<ul v-if="order.address_data != undefined">
						<li>Billing Address</li>
						<li>{{ order.address_data.name }}</li>
						<li>{{ order.address_data.province_name }}&nbsp;&nbsp;{{ order.address_data.city_name }}&nbsp;&nbsp;{{ order.address_data.county_name }}&nbsp;&nbsp;{{ order.address_data.address }}</li>
					</ul>
				</div> -->
				<div class="detail-order-goods">
					<div class="detail-order-goodsTitle">您的订单详情</div>
					<div class="cart-goods">
						<van-row v-for="goods in order.items" :key="goods.id" class="cart-goods-datail" type="flex" align="center" justify="start">
							<van-col>
                                <router-link :to="{path:'details',query:{id:goods.goods_id}}">
                                    <van-image width="90" lazy-load :src="goods.images" />
                                </router-link>
							</van-col>
							<van-col class="goods_xinxi">
								<van-row type="flex" justify="space-between" align="center">
									<van-col>
										<p v-for="(v,i) in goods.spec" :key="i">{{v.type}}:{{v.value}}</p>
										<p>数量:{{goods.buy_number}}</p>
									</van-col>
									<van-col>
										<van-button class="fr" size="mini" type="primary" @click="showReview(goods.goods_id,goods.id)" v-if="order.status == 4 && goods.comments == ''">提交
											评价</van-button>
                                        <van-button class="fr" size="mini" type="primary" :to="{path:'reviews'}" v-if="order.status == 4 && goods.comments != ''"> 显示评论</van-button>
									</van-col>
								</van-row>
							</van-col>
						</van-row>

						<!-- ------ -->
						<van-popup v-model="reviewbox" position="bottom" closeable :close-on-click-overlay="gb_overlay">
							<van-form>
								<van-row type="flex" align="center" class="terTest-make-title">
									<font class="fl">进行评论</font><span class="photo">最多上传4张照片</span>
								</van-row>
								<div class="makereview">
									<van-row class="make_star" type="flex" align="center" justify="start">
										<van-col span="9">商品质量</van-col>
										<van-col>
											<van-rate v-model="make_star_1" :size="12" color="#FE7A72" />
										</van-col>
									</van-row>
									<van-row class="make_star" type="flex" align="center" justify="start">
										<van-col span="9">运输速度</van-col>
										<van-col>
											<van-rate v-model="make_star_2" :size="12" color="#FE7A72" />
										</van-col>
									</van-row>
									<van-row class="make_star" type="flex" align="center" justify="start">
										<van-col span="9">客服服务</van-col>
										<van-col>
											<van-rate v-model="make_star_3" :size="12" color="#FE7A72" />
										</van-col>
									</van-row>
									<textarea class="make_text"
										placeholder="You may say more to help us make further improvement." v-model="make_text" required></textarea>
									<van-uploader :before-read="beforeRead" :after-read="afterRead" multiple :max-count="4" :accept="video.length > 0 ? 'image/*' : 'image/*,video/*'" v-model="file_list"/>
									<van-row type="flex" align="center" justify="center">
										<van-col span="24">
											<p @click="submitReviews">
												<van-button block type="primary">提交评价</van-button>
											</p>
										</van-col>
									</van-row>
								</div>
							</van-form>
						</van-popup>
					</div>
					<div class="cart-goods-subTotal">
						<ul>
							<li v-if="order.price > 0.00">单价:<span class="fr">￥ {{order.price}}</span></li>
							<li v-if="order.preferential_price > 0.00">折扣:<span class="fr"> - ￥ {{order.preferential_price}}</span></li>
							<li v-if="order.freight > 0.00">运费:<span class="fr">￥ {{order.freight}}</span></li>
							<li class="cart-subTotal-yourTotal" v-if="order.total_price">总价:<span class="fr">￥ {{order.total_price}}</span></li>
						</ul>
					</div>
				</div>
				<van-row type="flex" align="center" justify="center">
					<van-col span="20" v-if="order.status <= 1">
						<van-button block type="primary" @click="to_pay(order.id)">继续付款</van-button>
					</van-col>
				</van-row>
			</div>
		</div>
		<v-foot></v-foot>
	</div>
</template>

<script>
	// @ is an alias to /src
	export default {
		components: {},
		data() {
			return {
				make_star_1: 0,
				make_star_2: 0,
				make_star_3: 0,
				gb_overlay: false,
				reviewbox: false,
				order:{},
                make_text: '',
                images:[],
                video:[],
                file_list:[],
                goods_id: 0,
                order_detail_id: 0,
                id: 0
			}
		},
		created() {
			var id = this.order_id = this.id = this.$route.query.id;
			this.getData(id);
		},
		methods: {
			showReview(goods_id,order_detail_id) {
                this.goods_id = goods_id;
                this.order_detail_id = order_detail_id;
                this.reviewbox = true;
			},
			getData(id) {
				var _this = this;
				_this.POST('/api/order/Detail', {id: id}, function (res) {
					if(res.code == 0){
						window.console.info(res.data.data);
						_this.order = res.data.data;
					}else{
						_this.alert(res.msg);
					}
				})
			},
            to_pay(order_id){

                this.POST('api/order/pay',{id:order_id},function (){
                    this.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                    });
                })
            },
            beforeRead(file){
                if(this.file_list.length === 0){
                    return  true;
                }
                for (var i = 0; i < this.file_list.length; i++){
                    if(this.file_list[i].file.type.indexOf('video') != -1){
                        if(file.type.indexOf('video') != -1){
                            this.$toast('您最多只能上传一个视频');
                            return false;
                        }
                    }
                }
                return true;
            },
            afterRead(file){
                var file_type = file.file.type;
                var _self = this;
                var file_name = file.file.name;
                if(file_type.indexOf('image') == -1){
                    //视频
                    var formData = new FormData();
                    formData.append('file',file.file);
                    var url = "api/goods/uploadVideo";
                    this.POST(url, formData,function (ret) {
                        if(ret.code === 0){
                            _self.video[file_name] = ret.data.url;

                        }
                    })
                }else{
                    this.images[file_name] = file.content;
                }
            },
            submitReviews(){
                var url = "api/order/CommentsSave";
                var images_temp = [];
                var video_temp = [];
                for (var i= 0; i< this.file_list.length;i++){
                    if(this.images[this.file_list[i].file.name] != undefined){
                        images_temp.push(this.images[this.file_list[i].file.name])
                    }
                    if(this.video[this.file_list[i].file.name] != undefined){
                        video_temp.push(this.video[this.file_list[i].file.name])
                    }
                }
                var data = {
                    goods_id : [this.goods_id],
                    rating   : [Math.ceil((this.make_star_1+this.make_star_2+this.make_star_3) / 3)],
                    content  : [this.make_text],
                    imgs     : [images_temp],
                    id       : this.id,
                    order_detail_id     : [this.order_detail_id],
                    video    : video_temp
                }
                var _self = this;
                this.POST(url,data,function (ret){
                    if(ret.code === 0){
                        _self.$toast(ret.msg);
                        setTimeout(function (){
                            window.location.reload()
                        },500)
                    }else{
                        _self.$toast(ret.msg);
                    }
                })
            }
		},
	}
</script>